export default {
    root: {
        width: 'auto'
    }
};